import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthComponent } from '../auth/auth.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  logo = './assets/icon-128.png';
  constructor(public dialog: MatDialog) { }

  openDialog(mode: string): void {
    const dialogRef = this.dialog.open(AuthComponent, {
      height: '600px',
      width: '400px',
      data: { mode }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Header comp: The dialog was closed');
      // see https://material.angular.io/components/dialog/overview for example of setting result
    });
  }
}
